import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G fill="#696969" clipPath="url(#clip0_9205_1480)">
        <Path d="M9.047 5.39a.469.469 0 100-.937.469.469 0 000 .938z" />
        <Path d="M10.125.938h-.61v-.47a.469.469 0 10-.937 0v.47H6.445v-.47a.469.469 0 10-.937 0v.47h-2.11v-.47a.469.469 0 10-.937 0v.47h-.586A1.877 1.877 0 000 2.813v7.312C0 11.159.841 12 1.875 12h3.586a.469.469 0 000-.938H1.875a.939.939 0 01-.938-.937V2.812c0-.516.421-.937.938-.937h.586v.469a.469.469 0 10.937 0v-.469h2.11v.469a.469.469 0 10.937 0v-.469h2.133v.469a.469.469 0 10.938 0v-.469h.609c.517 0 .938.42.938.938v2.671a.469.469 0 00.937 0V2.813A1.877 1.877 0 0010.125.937z" />
        <Path d="M9.164 6.328a2.84 2.84 0 00-2.836 2.836A2.84 2.84 0 009.164 12 2.84 2.84 0 0012 9.164a2.84 2.84 0 00-2.836-2.836zm0 4.734a1.9 1.9 0 01-1.898-1.898 1.9 1.9 0 011.898-1.898 1.9 1.9 0 011.899 1.898 1.9 1.9 0 01-1.899 1.899z" />
        <Path d="M9.844 8.695h-.211v-.492a.469.469 0 10-.938 0v.961c0 .259.21.469.47.469h.679a.469.469 0 000-.938zM7.008 5.39a.469.469 0 100-.937.469.469 0 000 .938zM4.969 7.43a.469.469 0 100-.938.469.469 0 000 .938zM2.93 5.39a.469.469 0 100-.937.469.469 0 000 .938zM2.93 7.43a.469.469 0 100-.938.469.469 0 000 .938zM2.93 9.469a.469.469 0 100-.938.469.469 0 000 .938zM4.969 9.469a.469.469 0 100-.938.469.469 0 000 .938zM4.969 5.39a.469.469 0 100-.937.469.469 0 000 .938z" />
      </G>
      <Defs>
        <ClipPath id="clip0_9205_1480">
          <Path fill="#fff" d="M0 0H12V12H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
